var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-compare-wrapper"},[_c('div',{ref:"imageCompare",staticClass:"image-compare"},[_c('img',{attrs:{"src":("img/" + _vm.image1)}}),_c('img',{attrs:{"src":("img/" + _vm.image2)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }